import { ClasseDefWithUser } from 'types/classe/classe.def';
import { ElevesDashboardProf } from 'types/classe/maClasse';
import { sanitizePrice } from 'helpers/number/sanitizeCalul';
import { EleveCompetences } from 'views/EspaceProf/tabs/CompetencesTab';
import { mesComptencesFields } from 'domain/note/mesCompetences';

export const maClassecsv = (
  eleves: ElevesDashboardProf[],
  classe: ClasseDefWithUser,
  tab: number
) => {
  switch (tab) {
    case 0: {
      const newtabMyClass = classe?.users?.map(user => ({
        'Nom complet': `${user?.firstname} ${user?.lastname}`,
        Rôle: user.role,
        Email: user.email,
        Pseudo: user.username,
        'Mot de passe': user.mdp
      }));
      return newtabMyClass;
    }
    case 1: {
      const newtabSales = eleves.map(eleve => {
        const noteEleve = eleve.note;
        const unpayedCa = eleve.unpayedCa;
        if (!noteEleve) return null;

        return {
          'Nom complet': `${eleve?.firstname} ${eleve?.lastname}`,
          'CA (hors port)': `${sanitizePrice(
            noteEleve.qteca.toString()
          ).replaceAll('.', ',')} €`,
          'CA en attente (CB, Mandats, Virements)': `${sanitizePrice(
            unpayedCa.toString()
          ).replaceAll('.', ',')} €`,
          'Ventes totales': noteEleve.qtevente.toString(),
          'Ventes pro': noteEleve.qtepro.toString(),
          'Ventes additionnelles': noteEleve.qterebond.toString()
        };
      });
      return newtabSales;
    }
    case 2: {
      const newtabChallenges = eleves.map(eleve => {
        const noteEleve = eleve.note;
        if (!noteEleve) return null;

        return {
          'Nom complet': `${eleve?.firstname} ${eleve?.lastname}`,
          Challenge: `${noteEleve.moyennegenerale} / 20`,
          'CA (hors port)': `${noteEleve.cavente} / 20`,
          'Ventes totales': `${noteEleve.nbvente} / 20`,
          'Ventes pro': `${noteEleve.pro} / 20`,
          'Ventes additionnelles': `${noteEleve.venterebond} / 20`,
          Quiz: `${noteEleve.quiz} / 20`
        };
      });

      return newtabChallenges;
    }
    case 3: {
      const eleveCompetences: EleveCompetences[] = eleves.map(eleve => {
        if (!eleve.note) return null;

        return {
          firstname: eleve.firstname,
          lastname: eleve.lastname,
          competences: mesComptencesFields(eleve.note)
        };
      });
      if (eleveCompetences.length === 0) return null;

      const newtabSkills = eleveCompetences.map(eleve => ({
        Élèves: eleve.firstname + ' ' + eleve.lastname,
        Implication: eleve.competences[0].niveau + ' / 4',
        'Adaptation aux consignes': eleve.competences[1].niveau + ' / 4',
        'Dépassement de soi': eleve.competences[2].niveau + ' / 4',
        "Curiosité, envie d'apprendre": eleve.competences[3].niveau + ' / 4',
        'Négocier en B TO C': eleve.competences[4].niveau + ' / 4',
        'Négocier en B TO B': eleve.competences[5].niveau + ' / 4'
      }));

      return newtabSkills;
    }
  }
};
